import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { CompanyRowsTemplate as template } from './company-rows.template';
import { CompanyRowsStyles as styles } from './company-rows.styles';
import { AdvisorCompanyGrid, BuyerAdvisorCompany } from '../link-advisors';

@customElement({
  name: 'company-row',
  template: template,
  styles: styles,
})
export class LinkAdvisorsCompanyRow extends FASTElement {
  iconImg: HTMLElement;
  @attr selected = false;
  @attr data: BuyerAdvisorCompany;

  @observable showTooltip: boolean = false;

  radioClick() {
    this.$emit('buyer-company-selected', this.data.COMPANY_ID);
  }
}
